export enum Pages {
  DATA_COLLECTOR = "data_collector",
  DATA_WRITER = "data_writer",
  JOB_RUNNER = "job_runner",
  DATASETS_PAGE = "datasets",
}
